import axiosServices from './request';

const Raystask = axiosServices('/raystask/v1.0');

export default {
  // 提交创作任务
  submitAigcTaskResult: Raystask('post', 'creativeAigcTask/submitAigcTaskResult'),
  // 提交红榜周任务
  submitWeekTaskResult: Raystask('post', 'raysWeekTask/submitWeekTaskResult')
};
